import { c as _c } from "react/compiler-runtime";
import type { BaseNFT, NFTLite } from "@/entities/INFT";
import styles from "@/components/nft-image/NFTImage.module.scss";
import NFTHTMLRenderer from "@/components/nft-image/renderers/NFTHTMLRenderer";
import NFTImageRenderer from "@/components/nft-image/renderers/NFTImageRenderer";
import NFTModelRenderer from "@/components/nft-image/renderers/NFTModelRenderer";
import NFTVideoRenderer from "@/components/nft-image/renderers/NFTVideoRenderer";
import { getMediaType } from "@/components/nft-image/utils/media-type";
interface Props {
  nft: BaseNFT | NFTLite;
  animation: boolean;
  showThumbnail?: boolean | undefined;
  showOriginal?: boolean | undefined;
  height: 300 | 650 | "full";
  targetProfile?: string | undefined;
  showBalance: boolean;
  transparentBG?: boolean | undefined;
  id?: string | undefined;
}
export default function NFTImage(props) {
  const $ = _c(14);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = {
      height: {
        full: {
          heightStyle: "",
          imageStyle: styles.heightFull
        },
        650: {
          heightStyle: "",
          imageStyle: styles.height650
        },
        300: {
          heightStyle: styles.height300,
          imageStyle: ""
        }
      }
    };
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const styleConfig = t0;
  const {
    heightStyle,
    imageStyle
  } = styleConfig.height[props.height];
  const bgStyle = props.transparentBG ? styles.transparentBG : "";
  const safeHeightStyle = heightStyle ?? "";
  const safeImageStyle = imageStyle ?? "";
  const safeBgStyle = bgStyle ?? "";
  const mediaType = getMediaType(props.nft, props.animation);
  let t1;
  if ($[1] !== props || $[2] !== safeBgStyle || $[3] !== safeHeightStyle || $[4] !== safeImageStyle) {
    t1 = {
      ...props,
      heightStyle: safeHeightStyle,
      imageStyle: safeImageStyle,
      bgStyle: safeBgStyle
    };
    $[1] = props;
    $[2] = safeBgStyle;
    $[3] = safeHeightStyle;
    $[4] = safeImageStyle;
    $[5] = t1;
  } else {
    t1 = $[5];
  }
  const rendererProps = t1;
  switch (mediaType) {
    case "html":
      {
        let t2;
        if ($[6] !== rendererProps) {
          t2 = <NFTHTMLRenderer {...rendererProps} />;
          $[6] = rendererProps;
          $[7] = t2;
        } else {
          t2 = $[7];
        }
        return t2;
      }
    case "glb":
      {
        let t2;
        if ($[8] !== rendererProps) {
          t2 = <NFTModelRenderer {...rendererProps} />;
          $[8] = rendererProps;
          $[9] = t2;
        } else {
          t2 = $[9];
        }
        return t2;
      }
    case "video":
      {
        let t2;
        if ($[10] !== rendererProps) {
          t2 = <NFTVideoRenderer {...rendererProps} />;
          $[10] = rendererProps;
          $[11] = t2;
        } else {
          t2 = $[11];
        }
        return t2;
      }
    case "image":
    default:
      {
        let t2;
        if ($[12] !== rendererProps) {
          t2 = <NFTImageRenderer {...rendererProps} />;
          $[12] = rendererProps;
          $[13] = t2;
        } else {
          t2 = $[13];
        }
        return t2;
      }
  }
}